<template>
  <div
    class="counselor-grid__loader counselor"
    :class="{
      'circular-image': isTherapist,
    }"
  >
    <div class="lav-card__container">
      <span
        class="lav-card__thumbnail skeleton-loader"
        height="275"
        width="400"
        v-if="!isTherapist"
      />
      <div class="lav-card__text">
        <div class="lav-card__text-first">
          <span
            class="lav-card__thumbnail circular skeleton-loader"
            height="275"
            width="275"
            v-if="isTherapist"
          />
          <span class="lav-card__name skeleton-loader-text" />
          <span class="counselor-card__title skeleton-loader-text" />
          <div
            class="lavendla-rating counselor-card__rating skeleton-loader-text"
          />
          <span
            class="counselor-card__competence skeleton-loader-text"
            v-if="isTherapist"
          />
          <span
            class="counselor-card__languages skeleton-loader-text"
            v-if="isTherapist"
          />
        </div>
        <div class="lav-card__text-second">
          <span
            class="counselor-card-meeting-types skeleton-loader-text"
            v-if="isTherapist"
          />
          <span
            class="counselor-card__cta skeleton-loader large"
            style="height: 50px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CounselorArchiveCardSkeleton',

  props: {
    isTherapist: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
